import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";

const EditNowPlaying = () => {
  const { currentUser } = useContext(AuthContext);
  const [song, setSong] = useState("");
  const [artist, setArtist] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCurrent = async () => {
      try {
        const res = await axios.get("/api/now-playing");
        setSong(res.data.song);
        setArtist(res.data.artist);
      } catch (err) {
        console.log(err);
      }
    };
    fetchCurrent();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put("/api/now-playing", { song, artist });
      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  if (currentUser?.username !== "emma20106") {
    return (
      <div className="add-picture">
        <h2>Sorry, only the blog owner can update this!</h2>
      </div>
    );
  }

  return (
    <div className="add-picture">
      <h1>Update Now Playing</h1>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Song title"
          value={song}
          onChange={(e) => setSong(e.target.value)}
        />
        <input
          type="text"
          placeholder="Artist"
          value={artist}
          onChange={(e) => setArtist(e.target.value)}
        />
        <button type="submit">Save</button>
      </form>
    </div>
  );
};

export default EditNowPlaying;
